import { Button, ButtonProps, ModalFooterButton } from 'bold-ui'
import { Cancelable, throttle } from 'lodash'
import React, { useMemo } from 'react'
import { useFormState } from 'react-final-form'
import { CypressProps } from 'types/cypress'

type TrottledSubmit = ((handleSubmit: () => void) => void) & Cancelable

interface SubmitButtonProps extends ButtonProps, CypressProps {
  throttleSubmit?: boolean
  throttleDelay?: number
  handleSubmit: (event?: React.SyntheticEvent<HTMLFormElement>) => void
  isModalFooterButton?: boolean
}

export function SubmitButton(props: SubmitButtonProps) {
  const {
    throttleSubmit = false,
    throttleDelay = 2000,
    type = 'submit',
    handleSubmit,
    dataTestId,
    isModalFooterButton = false,
    ...rest
  } = props

  const { submitting } = useFormState({ subscription: { submitting: true } })

  const trottledSubmit: TrottledSubmit = useMemo(
    () => throttle((handleSubmit: () => void) => handleSubmit(), throttleDelay),
    [throttleDelay]
  )

  const Component = isModalFooterButton ? ModalFooterButton : Button

  return (
    <Component
      kind='primary'
      type={type}
      loading={submitting}
      disabled={submitting}
      onClick={throttleSubmit ? () => trottledSubmit(handleSubmit) : handleSubmit}
      data-testid={dataTestId}
      {...rest}
    />
  )
}
